<template>
  <div class="account-manage">
    <div class="section-title">账户管理</div>
    <div class="info-section">
      <div class="section-header">
        <h3>我的信息</h3>
      </div>
      <div class="info-content">
        <div class="info-item">
          <span class="label">我的头像：</span>
          <div class="avatar">
            <img src="@/assets/img/mall/avatar.png" alt="avatar" />
          </div>
        </div>
        <div class="info-item">
          <span class="label">我的昵称：</span>
          <span class="value" v-if="userInfo">{{ userInfo.userName || '未登录' }}</span>
        </div>
        <!-- <div class="info-item">
          <span class="label">我的ID：</span>
          <span class="value">{{ userInfo.id }}</span>
        </div> -->
        <div class="info-item">
          <span class="label">手机号：</span>
          <span class="value" v-if="userInfo">{{ userInfo.mobile | formatMobile }}</span>
          <!-- <el-button type="text" class="edit-btn" @click="handleEditMobile">修改</el-button> -->
        </div>
        <div class="info-item" style="padding: 20px" v-if="userInfo">
          <!-- <span class="label">我的密码：</span>
          <span class="value">******</span> -->
          <el-button type="danger" size="small" @click="handleLogout">退出登录</el-button>
        </div>
      </div>
    </div>

    <!-- 修改手机号弹窗 -->
    <!-- <el-dialog title="修改手机号" :visible.sync="mobileDialogVisible" width="400px" :close-on-click-modal="false">
      <el-form :model="mobileForm" :rules="mobileRules" ref="mobileForm" label-width="100px">
        <el-form-item label="新手机号" prop="mobile">
          <el-input v-model="mobileForm.mobile" placeholder="请输入新手机号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mobileDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitMobile" :loading="mobileLoading">确 定</el-button>
      </div>
    </el-dialog> -->

    <!-- 修改密码弹窗 -->
    <!-- <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="400px" :close-on-click-modal="false">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPassword" :loading="passwordLoading">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { Session } from '@/utils/storage'
import loginApi from '@/api/login'

export default {
  name: 'AccountManage',
  data() {
    // 验证手机号
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    // 验证确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      userInfo: null,
      // 修改手机号
      mobileDialogVisible: false,
      mobileLoading: false,
      mobileForm: {
        mobile: ''
      },
      mobileRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ]
      },
      // 修改密码
      passwordDialogVisible: false,
      passwordLoading: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.initUserInfo()
  },
  methods: {
    handleLogout() {
      Session.clear()
      this.userInfo = null
      this.$message.success('退出登录成功')
      setTimeout(() => {
        this.$router.push({
          path: '/pc/mall',
          query: {
            _t: Date.now()
          }
        })
      }, 1000)
    },
    initUserInfo() {
      const userInfo = Session.get('userInfo')
      if (userInfo) {
        this.userInfo = userInfo
      }
    },
    // 修改手机号
    handleEditMobile() {
      this.mobileForm.mobile = ''
      this.mobileDialogVisible = true
    },
    async submitMobile() {
      try {
        await this.$refs.mobileForm.validate()
        this.mobileLoading = true
        // TODO: 调用修改手机号接口
        this.$message.success('修改成功')
        this.mobileDialogVisible = false
      } catch (error) {
        console.log(error)
      } finally {
        this.mobileLoading = false
      }
    },
    // 修改密码
    handleEditPassword() {
      this.passwordForm.oldPassword = ''
      this.passwordForm.newPassword = ''
      this.passwordForm.confirmPassword = ''
      this.passwordDialogVisible = true
    },
    async submitPassword() {
      try {
        await this.$refs.passwordForm.validate()
        this.passwordLoading = true
        // TODO: 调用修改密码接口
        this.$message.success('修改成功')
        this.passwordDialogVisible = false
      } catch (error) {
        console.log(error)
      } finally {
        this.passwordLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.account-manage {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .info-section {
    background-color: #fff;
    border-radius: 4px;

    .section-header {
      padding: 15px 20px;
      border-bottom: 1px solid #eee;

      h3 {
        font-size: 16px;
        color: #333;
        margin: 0;
      }
    }

    .info-content {
      padding: 20px;

      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          width: 100px;
          text-align: right;
          color: #666;
        }

        .value {
          color: #333;
        }

        .avatar {
          width: 60px;
          height: 60px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .edit-btn {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
